import React from "react";
import { Swiper, SwiperSlide } from 'swiper/react';
// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

import { Navigation, Pagination, Autoplay } from 'swiper/modules';

const Slider = ({ items, pagination = false }) => {
    const previousButton = (
        <div style={{ position: 'relative', zIndex: 9 }} className="slider-prev-button hidden lg:flex !border bg-black !border-primary-color rounded-full p-2 w-[40px] h-[40px] justify-center items-center cursor-pointer translate-y-[170px] ml-[30px]">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-6 text-primary-color">
                <path strokeLinecap="round" strokeLinejoin="round" d="M10.5 19.5 3 12m0 0 7.5-7.5M3 12h18" />
            </svg>
        </div>
    )

    const nextButton = (
        <div style={{ position: 'relative', zIndex: 9 }} className="slider-next-button hidden lg:flex !border bg-black border-primary-color rounded-full p-2 w-[40px] h-[40px] justify-center items-center cursor-pointer translate-y-[170px] mr-[30px]">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-6 text-primary-color">
                <path strokeLinecap="round" strokeLinejoin="round" d="M13.5 4.5 21 12m0 0-7.5 7.5M21 12H3" />
            </svg>
        </div>
    )
    return (
        <>
            {
                items.length > 5 &&
                <div className="flex justify-between items-center">
                    {previousButton}
                    {nextButton}
                </div>
            }
            <Swiper
                style={{
                    '--swiper-pagination-color': '#E96F3A',
                    '--swiper-pagination-bullet-inactive-color': '#E96F3A',
                }}
                slidesPerView={3}
                spaceBetween={20}
                className="mySwiper"
                modules={[Navigation, Pagination, Autoplay]}
                loop={true}
                autoplay={{
                    delay: 3000,
                    pauseOnMouseEnter : true
                }}
                pagination={{
                    enabled: pagination,
                    dynamicBullets: true,
                }}
                navigation={{
                    enabled: true,
                    prevEl: '.slider-prev-button',
                    nextEl: '.slider-next-button',
                }}
                breakpoints={{
                    0: {
                        slidesPerView: 1.2,
                    },
                    768: {
                        slidesPerView: 3,
                    },
                    1024: {
                        slidesPerView: 5,
                    }
                }}
            >
                {
                    items.length && items.map((item, index) =>
                        <SwiperSlide key={index}>
                            {item}
                        </SwiperSlide>
                    )
                }
            </Swiper>
        </>
    );
}

export default Slider;
